import React from 'react'
import { connect } from 'react-redux'
import * as actions from '../../actions'
import OperacionesCupoNominadoView from '../../components/renominacionCupos/OperacionesCupoNominadoView'

function OperacionesCupoNominado (props) {
  const { cupo } = props

  return (
    <OperacionesCupoNominadoView
      cupo={cupo}
      openDialogRenominacion={props.openDialogRenominacion}
      deleteCupoNominado={props.deleteCupoNominado}
    />
  )
}

export default connect(null, actions)(OperacionesCupoNominado)
